const BASE = {
	BASE_URL: '/',
	APP_NAME: 'Rumis Form',
	APP_SHORT_NAME: 'RMK Form',
};

const SERVER = process.env.REACT_APP_SERVER || '';
const WSS = process.env.REACT_APP_WSS || '';

if (!SERVER) {
	console.error('CONFIG: REACT_APP_SERVER missing for MODE', window.MODE);
}

const API_SERVER = SERVER ? `${SERVER}/api` : undefined;

export type CONFIG_TYPE = typeof BASE & {
	SERVER: string;
	WSS: string;
	API_SERVER?: string;
};

export const CONFIG = {
	...BASE,
	SERVER,
	WSS,
	API_SERVER,
};

window.CONFIG = CONFIG;
